// frontend/src/services/SkillService.js
import axios from 'axios';

class SkillService {
  getAllSkills(sessionId) {
    return axios.get(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/skills`);
  }

  createSkill(sessionId, skill) {
    return axios.post(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/skills`, skill);
  }

  deleteSkill(sessionId, skillId) {
    return axios.delete(`${process.env.REACT_APP_API_URL}/sessions/${sessionId}/skills/${skillId}`);
  }
}

export default new SkillService();